var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjekt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12366",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2115 19.4038L17.1038 18.5193C16.7243 18.4359 16.4118 18.326 16.1663 18.1895C15.9208 18.0528 15.6872 17.8602 15.4655 17.6115L14.6307 17.9462L14.0922 17.1307L14.7807 16.5538C14.6706 16.1999 14.6155 15.8551 14.6155 15.5192C14.6155 15.1834 14.6706 14.8385 14.7807 14.4845L14.0922 13.9078L14.6307 13.0922L15.4655 13.427C15.6872 13.1653 15.9208 12.9695 16.1663 12.8395C16.4118 12.7093 16.7243 12.6026 17.1038 12.5192L17.2115 11.6345H18.2115L18.3193 12.5192C18.6988 12.6026 19.0112 12.7093 19.2568 12.8395C19.5023 12.9695 19.7359 13.1653 19.9578 13.427L20.7922 13.0922L21.3307 13.9078L20.6423 14.4845C20.7526 14.8385 20.8078 15.1834 20.8078 15.5192C20.8078 15.8551 20.7526 16.1999 20.6423 16.5538L21.3307 17.1307L20.7922 17.9462L19.9578 17.6115C19.7359 17.8602 19.5023 18.0528 19.2568 18.1895C19.0112 18.326 18.6988 18.4359 18.3193 18.5193L18.2115 19.4038H17.2115ZM17.7115 17.673C18.3 17.673 18.8061 17.4612 19.2297 17.0375C19.6536 16.6138 19.8655 16.1077 19.8655 15.5192C19.8655 14.9307 19.6536 14.4247 19.2297 14.001C18.8061 13.5773 18.3 13.3655 17.7115 13.3655C17.123 13.3655 16.6169 13.5773 16.1932 14.001C15.7696 14.4247 15.5577 14.9307 15.5577 15.5192C15.5577 16.1077 15.7696 16.6138 16.1932 17.0375C16.6169 17.4612 17.123 17.673 17.7115 17.673ZM4.6155 18C4.15517 18 3.77083 17.8458 3.4625 17.5375C3.15417 17.2292 3 16.8448 3 16.3845V5.6155C3 5.15517 3.15417 4.77083 3.4625 4.4625C3.77083 4.15417 4.15517 4 4.6155 4H9.59625L11.5963 6H19.3845C19.8448 6 20.2292 6.15417 20.5375 6.4625C20.8458 6.77083 21 7.15517 21 7.6155V9.9095C20.4937 9.60833 19.9597 9.38142 19.398 9.22875C18.8365 9.07625 18.2596 9 17.6673 9C15.8033 9 14.2548 9.649 13.022 10.947C11.7893 12.2452 11.173 13.7673 11.173 15.5135C11.173 15.9442 11.2153 16.3647 11.3 16.775C11.3847 17.1853 11.5116 17.5937 11.6808 18H4.6155Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjekt);
export default __webpack_public_path__ + "static/media/projekt.56f3b2f5fb6256f926ef87530f3a1a72.svg";
export { ForwardRef as ReactComponent };